import Link from 'next/link'
import { Project } from 'common/project'
import { generateSrcSet } from 'project/image-proxy-web'

export const AppStoreButton = () => {
  return (
    <Link target={'_blank'} href={Project.appStore}>
      <img
        {...generateSrcSet('/images/app/Apple.svg', 120, 40)}
        loading='lazy'
        alt={'Download on the App Store'}
        height={40}
        width={120}
      />
    </Link>
  )
}

export const GooglePlayButton = () => {
  return (
    <Link target={'_blank'} href={Project.playStore}>
      <img
        {...generateSrcSet('/images/app/Google.svg', 120, 40)}
        loading='lazy'
        alt={'Download on Google Play'}
        height={40}
        width={120}
      />
    </Link>
  )
}
